import { SHOULD_SHOW_SIGN_UP_BUTTON } from '@/constants/configConstants';
import { useCurrentUserContext } from './useCurrentUserContext';

export const useShouldDisplaySignup = () => {
  const { user, isLoading } = useCurrentUserContext();

  return {
    data: SHOULD_SHOW_SIGN_UP_BUTTON && !user?.sagemakerRestrictions,
    isLoading
  };
};
